export const APPLE = 'apple';
export const EMAIL = 'email';
export const FACEBOOK = 'facebook';
export const GOOGLE = 'google';
